var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiSc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.62 59.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "32.2 58.48 34.73 58.48 35.37 58.48 35.37 50.09"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.81,6.26c1.07-.16,2.17-.24,3.28-.24,11.73,0,21.23,9.27,21.23,20.72,0,.79-.05,1.57-.14,2.34-.05.39.03.78.22,1.11l4.26,7.48c.52.89,0,2-.99,2.22l-4.38.9v7.09c0,1.22-.99,2.22-2.23,2.22h-9.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.13,23.33c-.19,1.1-.29,2.25-.29,3.41,0,6.08,2.7,11.55,6.98,15.34v16.4h22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.25,46.12l1.52,1.51c1.58,1.58,3.72,2.46,5.96,2.46"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.13,23.33h7.66c-.48-.51-.76-1.2-.76-1.95,0-1.76,1.6-3.18,3.46-2.8,1.12.23,2.02,1.13,2.23,2.26.18.96-.13,1.87-.72,2.5h5.83v-5.82c.62.6,1.54.9,2.5.71,1.12-.2,2.04-1.09,2.26-2.22.37-1.85-1.04-3.46-2.8-3.46-.76,0-1.45.28-1.95.76v-7.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.81,39.17v-5.82c-.51.48-1.2.76-1.95.76-1.77,0-3.17-1.61-2.81-3.46.22-1.12,1.14-2.01,2.26-2.22.96-.17,1.87.12,2.5.72v-5.82h5.82c-.6.63-.9,1.55-.72,2.5.21,1.12,1.11,2.04,2.23,2.26,1.85.37,3.46-1.04,3.46-2.81,0-.75-.29-1.45-.76-1.95h5.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.48,10.86c-1.67-.29-3.11.98-3.11,2.58,0,.69.26,1.32.7,1.79H.75v-3.01C.75,5.89,5.89.75,12.22.75h3.02v5.31c.46-.43,1.1-.69,1.79-.69,1.58,0,2.84,1.4,2.59,3.05-.16,1.03-.97,1.9-1.99,2.12-.92.21-1.79-.07-2.39-.64v5.32h-5.32c.56-.59.83-1.46.64-2.36-.21-1.01-1.06-1.82-2.08-2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiSc);
export default __webpack_public_path__ + "static/media/DiSC.55250c20884bf5e9b3b88d0850e20b8e.svg";
export { ForwardRef as ReactComponent };